import React from "react"; 
import '../styles/Footer.css';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import logo from '../Assets/Images/asvf-logo.png';


export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <div className="footer-logo">
              <img src={logo} alt="Akij Foundation Vocational School" />
              <h3>Akij Foundation Vocational School</h3>
            </div>
            <div className="footer-copy">
              <p>Monowara Complex, Binnadangi, Jamirta, Singair, Manikganj.</p>
              
              <p>COPYRIGHT © {new Date().getFullYear()} Akij Foundation Vocational School</p>
            </div>
          </div>

          <div className="footer-links">
            <div>
              <a href="#about">About Akij INSAF</a>  
              <a href="#businesses">Diverse Businesses</a>
              <a href="#brands">Pride Brands</a>
              <a href="#video">Watch Video</a>
            </div>
            <div>
              <a href="#evolution">Evolution of Akij</a>
              <a href="#founder">Honorable Founder</a>
              <a href="#md">Revered Managing Director</a>
              <a href="#director">Respected Director</a>
            </div>
            <div>
              <a href="#team">Leadership Team</a>
              <a href="#events">Events</a>
              <a href="#certifications">Prestigious Certifications</a>
              <a href="#achievements">Achievements</a>
            </div> 
          </div>

          <div className="footer-social">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaYoutube /></a>
          </div> 
        </div>

        {/* <div className="footer-scroll-top">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>↑</button>
        </div>  */}
      </footer>
    </>
  );
}
